import ContentManager from "../../../managers/ContentManager";
import React, { useEffect, useState } from "react";
import InPageLoading from "../../../app-components/Loading/InPageLoading";
import contentStore from "../../../stores/contentStore";
import { useHookstate } from "@hookstate/core";
import { useContentManager } from "../../../../../hooks/useManagers";
import PdfViewer from "./PdfViewer";

export default function Resource() {
  const contentMgr = useContentManager();

  return (
    <>
      {contentMgr?.SelectedContent ? (
        <div className="resourceFrame">
          {contentMgr?.SelectedContent?.FileExt !== "pdf" ? (
            <img
              src={contentMgr.SelectedContent.ThumbnailFileUrl}
              id={contentMgr.SelectedContent.Title}
              alt={contentMgr.SelectedContent.Title}
            />
          ) : (
            <PdfViewer contentId={contentMgr?.SelectedContent?.Id} />
          )}
        </div>
      ) : (
        <InPageLoading />
      )}
    </>
  );
}
